import React from "react";
import { Icon } from "../../ui/UIElements/Icon";

/**
 * ReportCard Component
 * Reusable card component for displaying report options with download functionality
 */
const ReportCard = ({
  title,
  description,
  actionText,
  onAction,
  isLoading = false,
  loadingText = "Generating...",
  disabled = false,
  icon = "FileText",
  className = "",
  children,
}) => {
  return (
    <div
      className={`rounded-lg border border-gray-700 bg-gray-800 p-6 transition-colors hover:bg-gray-800/80 ${className}`}
    >
      <div className="mb-4 flex items-start justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-500/10">
            <Icon name={icon} className="h-5 w-5 text-blue-400" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-white">{title}</h3>
          </div>
        </div>
      </div>

      <p className="mb-6 text-sm leading-relaxed text-gray-400">
        {description}
      </p>

      {children && <div className="">{children}</div>}

      <button
        onClick={onAction}
        disabled={disabled || isLoading}
        className={`inline-flex items-center text-sm font-medium transition-colors ${
          disabled || isLoading
            ? "cursor-not-allowed text-gray-500"
            : "text-blue-400 hover:text-blue-300"
        }`}
      >
        {isLoading ? (
          <>
            <svg
              className="mr-2 h-4 w-4 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            {loadingText}
          </>
        ) : (
          <>
            {actionText}
            <Icon name="ExternalLink" className="ml-1 h-4 w-4" />
          </>
        )}
      </button>
    </div>
  );
};

export default ReportCard;
